<div class="overlay" [class.overlay--active]="enabled">
  <div class="overlay__background"></div>
  <div class="overlay__content">
    <ui-page-loader></ui-page-loader>
  </div>
</div>
